export { default, isPlainObject } from './deepmerge.esm.js';
